import type { GpoCommissionType, GpoOrderTermsSource } from 'apis/gpo-orders';

export const sourceLabels: Record<GpoOrderTermsSource, string> = {
  profile_default: 'Profile default',
  manual_override: 'Manual override',
  month_snapshot: 'Month snapshot',
  send_order: 'Set at send-order',
};

export const commissionBadgeLabel = (type: GpoCommissionType): string =>
  type === 'fixed' ? 'Fixed' : type === 'waived' ? 'Waived' : '%';

export const commissionBadgeColor = (type: GpoCommissionType): string =>
  type === 'fixed' ? 'purple' : type === 'waived' ? 'gray' : 'blue';
